export default __webpack_public_path__ + "static/media/Snd4.bf307d9e.mp3";